interface response {
  code: number;
  message: string;
}

export function call (targetId: number): Promise<response> {
  return request({
    url: '/gamecard/v2/share/assistance/call',
    data: {
      targetId,
    },
    type: 'POST',
  });
}
